import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const BlackLine = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '0.125rem',
  background: 'black',
  overflow: 'hidden',
});

export default BlackLine;
